import React from 'react';

/**
 * VoiceWaves — 5 vertical bars animated only when `active=true`.
 * CSS-only animation (more performant than canvas).
 */
export default function VoiceWaves({ active }) {
  return (
    <div
      className={`sv-voice-waves ${active ? 'sv-voice-waves--on' : ''}`}
      role="status"
      aria-live="polite"
      aria-label={active ? 'Reproduciendo voz' : 'Voz en silencio'}
      data-testid="voice-waves"
      data-active={active ? 'true' : 'false'}
    >
      {[0, 1, 2, 3, 4].map((i) => (
        <span key={i} className={`sv-wave-bar sv-wave-bar-${i}`} />
      ))}
    </div>
  );
}
